import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ClosingQuote() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-16 md:py-24" data-id="element-159">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-160">
        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="font-serif text-2xl md:text-3xl lg:text-4xl text-white italic leading-relaxed mb-4" data-id="element-161">
          "You were never a prisoner of the game.
          <br data-id="element-162" />
          <span className="text-teal-400" data-id="element-163">
            You were just learning how to play it awake.
          </span>
          "
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-10" data-id="element-164">
          <a href="#get-access" className="inline-flex items-center gap-3 px-10 py-4 text-base md:text-lg font-bold text-black bg-gradient-to-r from-teal-400 to-cyan-400 rounded-xl shadow-lg shadow-teal-500/30 hover:shadow-teal-500/50 hover:scale-105 transition-all duration-300 uppercase tracking-wide" data-id="element-165">
            ▶▶ GET THE PACK — Ebook + Audiobook →
          </a>
        </motion.div>
      </div>
    </section>;
}